export interface OtpPhoneLikeVerificationResponse {
  Code: string;
  TransactionId: string;
  DigitalIdentityVerificationType: string;
  DigitalIdentity: string;
  GenerationNumber: number;
}

export interface OtpPhoneVerificationResponse {
  Code: string;
  TransactionId: string;
  Phone: string;
  GenerationNumber: number;
}

function otpUnknownVerificationResponse(payload: string) {
  const json = atob(payload)
  return JSON.parse(json)
}

export function otpPhoneLikeVerificationResponse(payload: string) {
  return otpUnknownVerificationResponse(payload) as OtpPhoneLikeVerificationResponse
}

export function otpPhoneVerificationResponse(payload: string) {
  return otpUnknownVerificationResponse(payload) as OtpPhoneVerificationResponse
}
